import React, {useEffect, useRef} from 'react';
import {ReactComponent as SearchIcon} from "../../../asset/icons/searchIcon.svg";
import './style.scss'

function DBSearchFilter({className = '', placeholder, onClick, value = ''}) {
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.value = value
  }, [value])

  const click = () => {
    onClick(inputRef.current.value)
  }

  return (
    <div className={`DBSearchFilter ${className}`}>
      <button
        className="DBSearchFilter-btn"
        onClick={() => click()}>
        <SearchIcon/>
      </button>
      <input
        ref={inputRef}
        className='DBSearchFilter-input-search'
        type="text"
        placeholder={placeholder}
        onKeyUp={(event) => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            click()
          }
        }}
      />
    </div>
  );
}

export default DBSearchFilter;
